import React from "react";
import EmbeddedHelp from "../../app/common/EmbeddedHelp/EmbeddedHelp";

const DataDiscrepancy = () => {
  return (
    <div className="flex w-full flex-column pl-6">
      <h2>Data Discrepancy Template</h2>
      <EmbeddedHelp>
        Thank you for your time! Feedbacks helps us improve.
      </EmbeddedHelp>
    </div>
  );
};

export default DataDiscrepancy;
